import axios from 'axios';
import {getItem} from '../utils/storage';
import { getApiDomain } from '../agent/config';
import getV2AxiosInstance from '../utils/v2Axios.js';

function handleResponse(response){
  if(response.status==200){
    return response;
  }else{
    let error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

export function skipAdminTime(){
    return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Autodialer", {
        action: "skipAdministrativeTime",
        params: { agent_id: localStorage.getItem("agent_id") },
      })
      .then(handleResponse)
    };
}

export function getcontactImmediately(){
    
  return dispatch => {
      return getV2AxiosInstance()
      .post("/bridge/en/invoxapi/Autodialer", {
        action: "unlockContact",
        params: { agent_id: localStorage.getItem("agent_id") },
      })
      .then(handleResponse)
  };
}



// WEBPACK FOOTER //
// ./src/actions/autoDialerConfig.js